// extracted by mini-css-extract-plugin
export default {"header":"ProfileHeader_header__7cWqg"};